import { useClickOutside, useDisclosure } from '@mantine/hooks';
import React from 'react';
import { StyledDropdown } from './Dropdown.style';
import ChevronIcon from '~/assets/images/icons/chevron.svg';

export const Dropdown: React.FC<DropdownProps> = ({
  label,
  options,
  value,
  onChange,
  onReset,
}) => {
  const [isOpen, openHandlers] = useDisclosure(false);
  const ref = useClickOutside<HTMLUListElement>(handleClickOutside);

  function handleClickOutside() {
    if (isOpen) {
      openHandlers.close();
    }
  }

  const handleClick = () => {
    if (isOpen) {
      onReset();
      openHandlers.close();
    } else {
      openHandlers.toggle();
    }
  };

  const handleChange = (val: DropdownOption) => {
    onChange(val);
    openHandlers.close();
  }

  return (
    <StyledDropdown ref={ref} isOpen={isOpen} width={ref.current?.offsetWidth} className="dropdown">
      <li className="dropdown-value">
        <button onClick={handleClick}>
          <span>{isOpen || !value ? label : value.label}</span>
        </button>
        <ChevronIcon />
      </li>
      <ul className="dropdown-options">
        {options.map(({ label, value }, index) => (
          <li key={index}>
            <button
              tabIndex={isOpen ? 0 : -1}
              onClick={() => handleChange({label, value})}
            >
              {label}
            </button>
          </li>
        ))}
      </ul>
    </StyledDropdown>
  );
};

interface DropdownProps {
  options: DropdownOption[];
  value: DropdownOption;
  label: string;
  onChange: (value: DropdownOption) => void;
  onReset: () => void;
}

export interface DropdownOption {
  label: string;
  value: string;
}
